/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root.route'
import { Route as NoSiteRouteRouteImport } from './routes/no-site.route'
import { Route as DocumentationRouteRouteImport } from './routes/documentation.route'
import { Route as IndexRouteRouteImport } from './routes/_index.route'
import { Route as IndexIndexRouteRouteImport } from './routes/_index/index.route'
import { Route as ProcessDefinitionIdRouteRouteImport } from './routes/process-definition.$id.route'
import { Route as IndexProcessDefinitionsTemplateRouteRouteImport } from './routes/_index/process-definitions-template.route'
import { Route as IndexProcessDefinitionsArchivedRouteRouteImport } from './routes/_index/process-definitions-archived.route'
import { Route as IndexProcessDefinitionsRouteRouteImport } from './routes/_index/process-definitions.route'
import { Route as IndexJobsRouteRouteImport } from './routes/_index/jobs.route'

const NoSiteRouteRoute = NoSiteRouteRouteImport.update({
  id: '/no-site',
  path: '/no-site',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentationRouteRoute = DocumentationRouteRouteImport.update({
  id: '/documentation',
  path: '/documentation',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRouteRoute = IndexRouteRouteImport.update({
  id: '/_index',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexIndexRouteRoute = IndexIndexRouteRouteImport.update({
  id: '/',
  path: '',
  getParentRoute: () => IndexRouteRoute,
} as any)
const ProcessDefinitionIdRouteRoute =
  ProcessDefinitionIdRouteRouteImport.update({
    id: '/process-definition/$id',
    path: '/process-definition/$id',
    getParentRoute: () => rootRouteImport,
  } as any)
const IndexProcessDefinitionsTemplateRouteRoute =
  IndexProcessDefinitionsTemplateRouteRouteImport.update({
    id: '/process-definitions-template',
    path: '/process-definitions-template',
    getParentRoute: () => IndexRouteRoute,
  } as any)
const IndexProcessDefinitionsArchivedRouteRoute =
  IndexProcessDefinitionsArchivedRouteRouteImport.update({
    id: '/process-definitions-archived',
    path: '/process-definitions-archived',
    getParentRoute: () => IndexRouteRoute,
  } as any)
const IndexProcessDefinitionsRouteRoute =
  IndexProcessDefinitionsRouteRouteImport.update({
    id: '/process-definitions',
    path: '/process-definitions',
    getParentRoute: () => IndexRouteRoute,
  } as any)
const IndexJobsRouteRoute = IndexJobsRouteRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => IndexRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexIndexRouteRoute
  '/documentation': typeof DocumentationRouteRoute
  '/no-site': typeof NoSiteRouteRoute
  '/jobs': typeof IndexJobsRouteRoute
  '/process-definitions': typeof IndexProcessDefinitionsRouteRoute
  '/process-definitions-archived': typeof IndexProcessDefinitionsArchivedRouteRoute
  '/process-definitions-template': typeof IndexProcessDefinitionsTemplateRouteRoute
  '/process-definition/$id': typeof ProcessDefinitionIdRouteRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexIndexRouteRoute
  '/documentation': typeof DocumentationRouteRoute
  '/no-site': typeof NoSiteRouteRoute
  '/jobs': typeof IndexJobsRouteRoute
  '/process-definitions': typeof IndexProcessDefinitionsRouteRoute
  '/process-definitions-archived': typeof IndexProcessDefinitionsArchivedRouteRoute
  '/process-definitions-template': typeof IndexProcessDefinitionsTemplateRouteRoute
  '/process-definition/$id': typeof ProcessDefinitionIdRouteRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_index': typeof IndexRouteRouteWithChildren
  '/documentation': typeof DocumentationRouteRoute
  '/no-site': typeof NoSiteRouteRoute
  '/_index/jobs': typeof IndexJobsRouteRoute
  '/_index/process-definitions': typeof IndexProcessDefinitionsRouteRoute
  '/_index/process-definitions-archived': typeof IndexProcessDefinitionsArchivedRouteRoute
  '/_index/process-definitions-template': typeof IndexProcessDefinitionsTemplateRouteRoute
  '/process-definition/$id': typeof ProcessDefinitionIdRouteRoute
  '/_index/': typeof IndexIndexRouteRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/documentation'
    | '/no-site'
    | '/jobs'
    | '/process-definitions'
    | '/process-definitions-archived'
    | '/process-definitions-template'
    | '/process-definition/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/documentation'
    | '/no-site'
    | '/jobs'
    | '/process-definitions'
    | '/process-definitions-archived'
    | '/process-definitions-template'
    | '/process-definition/$id'
  id:
    | '__root__'
    | '/_index'
    | '/documentation'
    | '/no-site'
    | '/_index/jobs'
    | '/_index/process-definitions'
    | '/_index/process-definitions-archived'
    | '/_index/process-definitions-template'
    | '/process-definition/$id'
    | '/_index/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRouteRoute: typeof IndexRouteRouteWithChildren
  DocumentationRouteRoute: typeof DocumentationRouteRoute
  NoSiteRouteRoute: typeof NoSiteRouteRoute
  ProcessDefinitionIdRouteRoute: typeof ProcessDefinitionIdRouteRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/no-site': {
      id: '/no-site'
      path: '/no-site'
      fullPath: '/no-site'
      preLoaderRoute: typeof NoSiteRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documentation': {
      id: '/documentation'
      path: '/documentation'
      fullPath: '/documentation'
      preLoaderRoute: typeof DocumentationRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_index': {
      id: '/_index'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_index/': {
      id: '/_index/'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof IndexIndexRouteRouteImport
      parentRoute: typeof IndexRouteRoute
    }
    '/process-definition/$id': {
      id: '/process-definition/$id'
      path: '/process-definition/$id'
      fullPath: '/process-definition/$id'
      preLoaderRoute: typeof ProcessDefinitionIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_index/process-definitions-template': {
      id: '/_index/process-definitions-template'
      path: '/process-definitions-template'
      fullPath: '/process-definitions-template'
      preLoaderRoute: typeof IndexProcessDefinitionsTemplateRouteRouteImport
      parentRoute: typeof IndexRouteRoute
    }
    '/_index/process-definitions-archived': {
      id: '/_index/process-definitions-archived'
      path: '/process-definitions-archived'
      fullPath: '/process-definitions-archived'
      preLoaderRoute: typeof IndexProcessDefinitionsArchivedRouteRouteImport
      parentRoute: typeof IndexRouteRoute
    }
    '/_index/process-definitions': {
      id: '/_index/process-definitions'
      path: '/process-definitions'
      fullPath: '/process-definitions'
      preLoaderRoute: typeof IndexProcessDefinitionsRouteRouteImport
      parentRoute: typeof IndexRouteRoute
    }
    '/_index/jobs': {
      id: '/_index/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof IndexJobsRouteRouteImport
      parentRoute: typeof IndexRouteRoute
    }
  }
}

interface IndexRouteRouteChildren {
  IndexJobsRouteRoute: typeof IndexJobsRouteRoute
  IndexProcessDefinitionsRouteRoute: typeof IndexProcessDefinitionsRouteRoute
  IndexProcessDefinitionsArchivedRouteRoute: typeof IndexProcessDefinitionsArchivedRouteRoute
  IndexProcessDefinitionsTemplateRouteRoute: typeof IndexProcessDefinitionsTemplateRouteRoute
  IndexIndexRouteRoute: typeof IndexIndexRouteRoute
}

const IndexRouteRouteChildren: IndexRouteRouteChildren = {
  IndexJobsRouteRoute: IndexJobsRouteRoute,
  IndexProcessDefinitionsRouteRoute: IndexProcessDefinitionsRouteRoute,
  IndexProcessDefinitionsArchivedRouteRoute:
    IndexProcessDefinitionsArchivedRouteRoute,
  IndexProcessDefinitionsTemplateRouteRoute:
    IndexProcessDefinitionsTemplateRouteRoute,
  IndexIndexRouteRoute: IndexIndexRouteRoute,
}

const IndexRouteRouteWithChildren = IndexRouteRoute._addFileChildren(
  IndexRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRouteRoute: IndexRouteRouteWithChildren,
  DocumentationRouteRoute: DocumentationRouteRoute,
  NoSiteRouteRoute: NoSiteRouteRoute,
  ProcessDefinitionIdRouteRoute: ProcessDefinitionIdRouteRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
